module.exports = __webpack_public_path__ + "static/logo-nodejs-46f758661588703b190fb4d2aae3847a.png";